import api from './api';

export const tagService = {
   getAll: async (includeBlogCount = false) => {
      const response = await api.get('/tags', {
         params: { includeBlogCount },
      });
      return response.data;
   },

   getById: async (id) => {
      const response = await api.get(`/tags/${id}`);
      return response.data;
   },

   getBySlug: async (slug) => {
      const response = await api.get(`/tags/slug/${slug}`);
      return response.data;
   },

   create: async (tagData) => {
      const response = await api.post('/tags', tagData);
      return response.data;
   },

   update: async (id, tagData) => {
      const response = await api.put(`/tags/${id}`, tagData);
      return response.data;
   },

   delete: async (id) => {
      const response = await api.delete(`/tags/${id}`);
      return response.data;
   },

   search: async (query, limit = 20) => {
      const response = await api.get('/tags/search', {
         params: { q: query, limit },
      });
      return response.data;
   },
};
